var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTablerLibrary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.29102 5.90313C7.29102 5.16632 7.58371 4.45969 8.10471 3.93869C8.62571 3.41769 9.33234 3.125 10.0691 3.125H19.0962C19.4611 3.125 19.8223 3.19686 20.1594 3.33647C20.4964 3.47609 20.8027 3.68072 21.0607 3.93869C21.3186 4.19667 21.5233 4.50293 21.6629 4.83998C21.8025 5.17704 21.8744 5.5383 21.8744 5.90313V14.9302C21.8744 15.295 21.8025 15.6563 21.6629 15.9934C21.5233 16.3304 21.3186 16.6367 21.0607 16.8946C20.8027 17.1526 20.4964 17.3572 20.1594 17.4969C19.8223 17.6365 19.4611 17.7083 19.0962 17.7083H10.0691C9.33234 17.7083 8.62571 17.4156 8.10471 16.8946C7.58371 16.3736 7.29102 15.667 7.29102 14.9302V5.90313Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17917 7.56249C3.85937 7.74419 3.59338 8.0073 3.40823 8.3251C3.22307 8.64291 3.12535 9.00406 3.125 9.37186V19.7885C3.125 20.9344 4.0625 21.8719 5.20833 21.8719H15.625C16.4063 21.8719 16.8313 21.4708 17.1875 20.8302M11.4583 7.29166H16.6667M11.4583 10.4167H17.7083M11.4583 13.5417H14.5833",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablerLibrary);
export default __webpack_public_path__ + "static/media/tabler_library.af4508b1516d638ae7c0399692c01a91.svg";
export { ForwardRef as ReactComponent };